import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { switchMap, catchError, of, tap, map } from 'rxjs';

import { ToastService } from '@mode/shared/util-toast';
import * as GoogleAccountActions from './google-account.actions';
import { GoogleAccountClientService } from '../../google-account/google-account-client.service';

@Injectable()
export class GoogleAccountEffects {
  private actions$ = inject(Actions);

  constructor(
    private _googleAccountClient: GoogleAccountClientService,
    private _toastService: ToastService,
    private _window: Window
  ) {}

  disconnectGoogleAccount$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GoogleAccountActions.disconnectGoogleAccount),
      switchMap(({ disconnectUrl }) => this._googleAccountClient.disconnect(disconnectUrl)),
      map(() => GoogleAccountActions.disconnectGoogleAccountSuccess()),
      tap(() => this._window.location.reload()),
      catchError((error) => {
        console.error('Error', error);
        return of(GoogleAccountActions.disconnectGoogleAccountFailure());
      })
    )
  );

  disconnectGoogleAccountFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GoogleAccountActions.disconnectGoogleAccountFailure),
        tap(() => this._toastService.error('Failed to disconnect Google Account. Please try again.'))
      ),
    { dispatch: false }
  );
}
